/* global document */

const DEFAULT_TITLE = 'Untitled';

export default function getArticleTitle(str) {
    if (typeof document === 'undefined') {
        return '';
    }
    
    let title;
    const div = document.createElement('div');
    
    div.innerHTML = str.trim();
    
    if (div.childNodes.length > 0) {
        title = div.textContent;
    } else {
        title = str;
    }

    if (!title || title.trim().length === 0) {
        title = DEFAULT_TITLE;
    }

    return title;
}